const userRolesList = ['isTeacher', 'isStudent', 'isAdmin', 'isCoordinator'];
const getUserRoleText = (userData) => {
  let userRoleText = '';
  userRolesList.some((role) => {
    userRoleText = userData[role] ? role : userRoleText;
    return userData[role];
  });
  return userRoleText;
};

export default getUserRoleText;
